import '../../resources/css/dashboard/HoodMonitor.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import { GET_DEVICE_DETAIL_FAIL } from '../../actions/dashboard/index';
import { getDevicesQuantityInCountry, forwardMap, WAIT_INIT_MAP } from '../../actions/map/index';
import { forwardLogin } from '../../actions/login/index';
import MapGroup from '../../components/dashboard/MapGroup';
import MapDetail from '../../components/dashboard/MapDetail';
import Loading from '../../components/common/Loading';

class HoodMonitorPage extends Component {

  // constructor(props) {
  //   super(props);

    // bind this props to function
    // this.clickMap = this.clickMap.bind(this);
  // };

  // clickMap = (mac) => {
  //   const { idToken, getDeviceDetail } = this.props;
  //   getDeviceDetail(idToken, mac);
  // }

  reloadList = (e) => {
    const { idToken, getDevicesQuantityInCountry, forwardMap } = this.props;
    if (idToken) {
      forwardMap();
      getDevicesQuantityInCountry(idToken);
    }
  }

  componentDidMount() {
    const { idToken, getDevicesQuantityInCountry, mapStatus, forwardLogin, history, dashboardStatus } = this.props;
    if (mapStatus === WAIT_INIT_MAP) {
      if (idToken) {
        getDevicesQuantityInCountry(idToken);  
      }
    } else if (dashboardStatus === GET_DEVICE_DETAIL_FAIL) {
      forwardLogin("Connect timeout, please relogin.");
      history.push("/Login");
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {        
    const { mapStatus } = this.props;

    if (prevProps.status !== mapStatus) {
        // init do init
        if (mapStatus === WAIT_INIT_MAP) {
          this.reloadList();
        }
    }
  }

  render() {
    const { idToken, devices, loading, monitorOnline, monitorOffline } = this.props;
    let renderMapGroups;
    if (loading) {
      renderMapGroups = <Loading loading={loading}></Loading>;
    } else {
      renderMapGroups = <MapGroup idToken={idToken} devices={devices} clickMap={this.clickMap}></MapGroup>;
    }

    return (
      <div className='hood-monitor'>
        <div className='header-bar'>
          <Row>
            <div className='area-header-title'>
              <div className='header-title'>Hood Monitor</div>
            </div>
            <div className='area-device-amount'>
              <div className='amount-title'>Online Device(s)</div>
              <div className='amount-number online'>{ monitorOnline }</div>
            </div>
            <div className='area-device-amount'>
              <div className='amount-title'>Offline Device(s)</div>
              <div className='amount-number office'>{ monitorOffline }</div>
            </div>
            <div className='area-list-btns'>
              <span className='area-icon-btn-reload'><span className='icon-btn-reload' onClick={() => this.reloadList()} /></span>
            </div>
          </Row>
        </div>
        <div className='dashboard-map'>
          { renderMapGroups }
        </div>
        <div className='dashboard-map-info'>
          <MapDetail></MapDetail>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    devices: state.dashboardReducers.devices,    
    errMsg: state.dashboardReducers.errMsg,
    dashboardStatus: state.dashboardReducers.status,
    mapStatus: state.mapReducers.status,
    monitorOnline: state.mapReducers.monitorOnline,
    monitorOffline: state.mapReducers.monitorOffline,
    loading: state.mapReducers.countryLoading
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardLogin, forwardMap, getDevicesQuantityInCountry }
)(HoodMonitorPage))
